<div id="template-editor-container" *ngIf="!loading; else loadingTemplate">
  <h1>{{ title }}</h1>
  <div class="editor-content">
    <form [formGroup]="formGroup" *ngIf="formGroup">
      <dx-text-box
        formControlName="name"
        label="Name*"
        labelMode="floating"
        stylingMode="outlined"
        [validationStatus]="formGroup.controls.name.errors && formGroup.controls.name.touched ? 'invalid' : 'valid'"
        [validationErrors]="[{ type: 'required', message: 'Name is mandatory!' }]"
      >
      </dx-text-box>
      <dx-text-area formControlName="description" label="Description" labelMode="floating" stylingMode="outlined"></dx-text-area>
      <dx-select-box
        formControlName="vmImageId"
        label="Image*"
        labelMode="floating"
        stylingMode="outlined"
        [dataSource]="this.vmImages"
        valueExpr="id"
        fieldTemplate="field"
        [validationStatus]="formGroup.controls.vmImageId.errors && formGroup.controls.vmImageId.touched ? 'invalid' : 'valid'"
        [validationErrors]="[{ type: 'required', message: 'Iamge is mandatory!' }]"
      >
        <div *dxTemplate="let data of 'field'">
          <dx-text-box [value]="data ? data.name + ' - ' + data.version : ''" [inputAttr]="{ 'aria-label': 'Name' }"></dx-text-box>
        </div>
        <div *dxTemplate="let data of 'item'">{{ data.name }} - {{ data.version }}</div>
      </dx-select-box>
    </form>
    <h3>Demos</h3>
    <brd-demos-grid
      [assets$]="assets$"
      [readonly]="true"
      [hideColumns]="['creationDate', 'updateBy', 'owner', 'lastUpdate', 'demoAssetSize', 'draft', 'default']"
      [enableSelection]="true"
      (contentReadyEmitter)="onGridContentReady($event)"
    ></brd-demos-grid>
  </div>
  <div class="action-bar">
    <dx-button stylingMode="text" type="danger" [width]="120" (onClick)="cancel()">CANCEL</dx-button>
    <dx-button stylingMode="contained" type="default" [width]="120" (onClick)="saveAsset()">SUBMIT</dx-button>
  </div>
</div>
<div class="submitting" *ngIf="submitting">
  <ng-container *ngTemplateOutlet="loadingTemplate"></ng-container>
</div>
<ng-template #loadingTemplate>
  <div class="loader-container">
    <mat-progress-spinner diameter="60" mode="indeterminate" strokeWidth="5"></mat-progress-spinner>
  </div>
</ng-template>
